export const STAGES = { antes: 'Antes', durante: 'Durante', despues: 'Después' };
export const SERVICE_TYPES = {
  ambulancia: 'Ambulancia', servicio_medico: 'Servicio médico', seguridad_privada: 'Seguridad privada',
  proteccion_civil: 'Protección civil', bomberos_privados: 'Bomberos privados', limpieza: 'Limpieza',
  logistica: 'Logística', otro: 'Otro',
};
export const FINDING_STATUS = {
  abierto: 'Abierto', en_atencion: 'En atención', por_validar: 'Por validar',
  mitigado: 'Mitigado', no_mitigado: 'No mitigado',
};
export const rows = (data) => Array.isArray(data) ? data : data?.items || [];
// #Fase3-G1 — Las lecturas toleran históricos; las altas conservan desconocidos para que la API los rechace.
export const canonicalStage = (value) => {
  const key = String(value ?? 'antes').trim().toLowerCase();
  const aliases = {
    pre_checklist: 'antes', 'pre-checklist': 'antes', audit: 'antes', auditoria: 'antes', otro: 'antes',
    post_checklist: 'despues', 'post-checklist': 'despues',
  };
  return aliases[key] || key;
};
export const normalizeStage = (value) => {
  const stage = canonicalStage(value);
  return Object.hasOwn(STAGES, stage) ? stage : 'antes';
};
export const INCIDENT_SEVERITIES = { menor: 'Menor', mayor: 'Mayor', critico: 'Crítico' };
export const INCIDENT_STATUS = { abierto: 'Abierto', en_proceso: 'En proceso', cerrado: 'Cerrado' };
export const PROVIDER_STATUS = {
  confirmado: 'Confirmado', presente: 'Presente', no_se_presento: 'No se presentó', cancelado: 'Cancelado',
};
export const isActiveTeamUser = (user) => user.role === 'levantador' && user.is_active !== false &&
  !['inactivo', 'suspendido', 'inactive', 'suspended'].includes(user.status);
export const eventTeamIds = (event) => [...new Set([
  ...(event?.assigned_user_ids || []), event?.assigned_levantador_id,
].filter(Boolean))];

// #Fase3-G3 — Cambiar principal revoca al anterior; conservarlo requiere seleccionarlo después explícitamente.
export function changePrincipal(form, next) {
  return { ...form, assigned_levantador_id: next,
    assigned_user_ids: (form.assigned_user_ids || []).filter((id) => id !== form.assigned_levantador_id && id !== next),
  };
}
export const canValidateFinding = (user, event) => user?.role !== 'cliente' && (typeof event?.permissions?.can_validate === 'boolean'
  ? event.permissions.can_validate : user?.role === 'super_admin' || (
  user?.role === 'lider_proyecto' && !!user.id &&
  [event?.assigned_leader_id, event?.project_leader_id].includes(user.id)
));

// #Fase3-G11 — Recorre páginas acotadas para no perder registros al crecer el evento o catálogo.
export async function fetchAllRows(list, params = {}, limit = 200) {
  const result = [];
  let skip = 0;
  while (true) {
    const { data } = await list({ ...params, skip, limit });
    const page = rows(data);
    result.push(...page);
    skip += page.length;
    if (!page.length || (data?.total != null ? skip >= data.total : page.length < limit)) return result;
  }
}

export const isLeader = (role) => ['super_admin', 'lider_proyecto'].includes(role);
export const canWork = (user, event) => isLeader(user?.role) || (
  user?.role === 'levantador' && !!user.id && (
    event?.assigned_levantador_id === user.id || event?.assigned_user_ids?.includes(user.id)
  )
);

// R12: las fotos iniciales nunca acreditan la corrección, sin importar su fecha.
export function hasMitigationEvidence(finding) {
  return !!(finding.final_evidence?.length || finding.evidence?.length ||
    (finding.actions || []).some(action => action.evidence?.length));
}

// #Fase3-B3 — Oculta transiciones inválidas; la API conserva la autoridad de acceso.
export function findingPermissions(finding, user, event) {
  const final = ['mitigado', 'no_mitigado'].includes(finding.status);
  const work = canWork(user, event);
  return {
    action: work && ['abierto', 'en_atencion'].includes(finding.status),
    evidence: work && ['abierto', 'en_atencion'].includes(finding.status),
    propose: work && ['abierto', 'en_atencion'].includes(finding.status) && hasMitigationEvidence(finding),
    validate: canValidateFinding(user, event) && ['por_validar', 'en_atencion'].includes(finding.status),
    reopen: canValidateFinding(user, event) && final,
  };
}

export const openFinding = finding => ['abierto', 'en_atencion', 'por_validar'].includes(finding.status);
export const findingsForStage = (items, stage) => items.filter(item => stage !== 'durante' || item.stage === stage ||
  (stage === 'durante' && item.stage === 'antes' && openFinding(item)));
export const personName = (record, field) => record?.[`${field}_name`] ||
  record?.[field]?.name || 'Usuario no disponible';
